<template>
<div class="chapter">
<div class="inner_page">
<a id="page_3"></a>
<h1 class="toc-title"><span class="bold">CONTENTS</span></h1>
<h2 class="toca"><a href="#/xhtml/03_Glossary#gloss">Glossary</a></h2>
<h2 class="toca"><a href="#/xhtml/04_Timeline#time">Timeline</a></h2>
<h2 class="toca"><a href="#/xhtml/05_Introduction#intro">Introduction</a></h2>
<h2 class="toc"><span href="#/xhtml/06_Chapter01#chapter1" title="Link target outside of Sample">1. Chairman Mao’s Volunteers</span></h2>
<h2 class="toc"><span href="#/xhtml/07_Chapter02#chapter2" title="Link target outside of Sample">2. Red Phantom</span></h2>
<h2 class="toc"><span href="#/xhtml/08_Chapter03#chapter3" title="Link target outside of Sample">3. Air Superiority Challenged</span></h2>
<h2 class="toc"><span href="#/xhtml/09_Chapter04#chapter4" title="Link target outside of Sample">4. A Dark Thanksgiving</span></h2>
<h2 class="toc"><span href="#/xhtml/10_Chapter05#chapter5" title="Link target outside of Sample">5. A Place Called Chosin</span></h2>
<h2 class="toc"><span href="#/xhtml/11_Chapter06#chapter6" title="Link target outside of Sample">6. MacArthur’s Dunkirk</span></h2>
<h2 class="toc"><span href="#/xhtml/12_Chapter07#chapter7" title="Link target outside of Sample">7. The Sacred Struggle</span></h2>
<h2 class="tocb"><span href="#/xhtml/13_Bibliography#bib" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?e48659a8